import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Train = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M6 9C6 6.23858 8.23857 4 11 4H21C23.7614 4 26 6.23858 26 9V14.988C26.0001 14.9968 26.0001 15.0057 26 15.0145V23C26 24.675 25.1763 26.1577 23.9119 27.0651L24.832 28.4453C25.1384 28.9048 25.0142 29.5257 24.5547 29.8321C24.0952 30.1384 23.4743 30.0142 23.1679 29.5547L22.0569 27.8881C21.7162 27.9614 21.3626 28 21 28H11C10.6374 28 10.2838 27.9614 9.94312 27.8881L8.83205 29.5547C8.52569 30.0142 7.90483 30.1384 7.4453 29.8321C6.98577 29.5257 6.86159 28.9048 7.16795 28.4453L8.08811 27.0651C6.82368 26.1577 6 24.675 6 23V15.0145C5.99988 15.0057 5.99988 14.9968 6 14.9879V9ZM8 16.1173V23C8 24.6569 9.34314 26 11 26H21C22.6568 26 24 24.6569 24 23V16.1173L16.9939 16.8957C16.3333 16.9691 15.6667 16.9691 15.0061 16.8957L8 16.1173ZM24 14.105L16.773 14.908C16.2593 14.965 15.7407 14.965 15.227 14.908L8 14.105V9C8 7.34315 9.34314 6 11 6H21C22.6568 6 24 7.34315 24 9V14.105ZM16 20C15.4477 20 15 20.4477 15 21C15 21.5523 15.4477 22 16 22C16.5523 22 17 21.5523 17 21C17 20.4477 16.5523 20 16 20ZM13 21C13 19.3431 14.3431 18 16 18C17.6569 18 19 19.3431 19 21C19 22.6569 17.6569 24 16 24C14.3431 24 13 22.6569 13 21Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Train;
